import { CANTRATE_ID } from '@webapp/common/resources/constants';

import type { QuestionActor } from '@webapp/survey/src/machine/question-machine';

import type { AnswersRequest } from '../queries-api';

import { QuestionSimpleApi } from './common/simple';

export class StarApi extends QuestionSimpleApi {
    public query(questionActor: QuestionActor): AnswersRequest {
        const { responseActor, id } = questionActor.getSnapshot().context;
        const { comment, value } = responseActor.getSnapshot().context;
        const int = value as number;
        const data = [int === CANTRATE_ID ? { bool: true, cantRate: true } : { bool: int > 0, int, comment }];
        return {
            question: id,
            data,
            comment,
        };
    }
}
